/**
 * displayName.js — Formatage AFFICHAGE des noms (ne modifie JAMAIS la base).
 *
 * Convention bulletin scolaire FR : NOM en MAJUSCULES, Prénom en Capitale initiale.
 * Les noms sont stockés en minuscules en base ; on ne corrige qu'à l'affichage.
 *
 * Copie synchronisée. SOURCE CANONIQUE : api/libs/formatters/displayName.js
 * Toute modif de logique doit être répercutée dans toutes les copies.
 */

// Prénom : 1re lettre de chaque mot en majuscule, reste en minuscule.
// Séparateurs gérés : espace, trait d'union, apostrophe (Jean-Pierre, N'Guyen).
// Accents latins gérés (Éric). Entrée vide/null -> "".
export function formatFirstName(value) {
  if (value === null || value === undefined) return "";
  return String(value)
    .trim()
    .replace(/\s+/g, " ")
    .toLowerCase()
    .replace(/(^|[\s\-'’])([a-zà-öø-ÿ])/g, function (m, sep, ch) {
      return sep + ch.toUpperCase();
    });
}

// Nom de famille : tout en MAJUSCULES. Entrée vide/null -> "".
export function formatLastName(value) {
  if (value === null || value === undefined) return "";
  return String(value).trim().replace(/\s+/g, " ").toUpperCase();
}

// "Prénom NOM" à partir d'un objet profil { firstName, lastName }.
export function formatProfilName(profil) {
  if (!profil) return "";
  return (formatFirstName(profil.firstName) + " " + formatLastName(profil.lastName)).trim();
}
